var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('componentHeader'),_c('componentMustLoginSection'),_c('componentSubscribeResearcherSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }